import { render, staticRenderFns } from "./Points_history_block.vue?vue&type=template&id=38aff806&scoped=true"
import script from "./Points_history_block.vue?vue&type=script&lang=js"
export * from "./Points_history_block.vue?vue&type=script&lang=js"
import style0 from "./Points_history_block.vue?vue&type=style&index=0&id=38aff806&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aff806",
  null
  
)

export default component.exports